export const orgs: Array<{
  id: string
  name: string
  didOrHandle: string
  description?: string
}> = [
  {
    id: 'tellus',
    name: 'Tellus',
    didOrHandle: 'did:plc:tellus',
    description: 'Official Tellus organization account',
  },
]

export const assignments: Array<{
  did: string
  badges: Array<
    'TELLUS_VERIFIED' | 'TELLUS_STAFF' | 'ORG_OFFICIAL' | 'ORG_MEMBER'
  >
  orgId?: string
  issuedAt?: string
  note?: string
}> = [
  {
    did: 'did:plc:tellus-staff-test',
    badges: ['TELLUS_VERIFIED', 'TELLUS_STAFF'],
    issuedAt: '2024-10-01T00:00:00.000Z',
    note: 'Test: Tellus staff + verified',
  },
  {
    did: 'did:plc:tellus-org-test',
    badges: ['ORG_OFFICIAL'],
    orgId: 'tellus',
    issuedAt: '2024-10-01T00:00:00.000Z',
    note: 'Test: official organization',
  },
  {
    did: 'did:plc:tellus-member-test',
    badges: ['ORG_MEMBER'],
    orgId: 'tellus',
    issuedAt: '2024-10-01T00:00:00.000Z',
    note: 'Test: organization member',
  },
  {
    did: 'did:plc:jtwvncowqgtrtp6nq5vbvpoi',
    badges: ['TELLUS_VERIFIED', 'TELLUS_STAFF'],
    issuedAt: new Date().toISOString(),
    note: 'My account (test)',
  },
]
